export default __webpack_public_path__ + "static/media/EagleIcon.fd3f0fac.svg";